import { useRoute } from '#imports'
import { computed, ref } from 'vue'

import { filterSelectedOfferABTestedPaymentMethods } from '@backmarket/nuxt-layer-payment/methods/helpers/filterABTestedPaymentMethods'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { useFetchPickersInternal } from './composables/useFetchPickersInternal'

export function useFetchPickers(route = useRoute()) {
  const pickersResponseCacheTagHeader = ref('')

  const experiments = useExperiments()

  const response = useFetchPickersInternal(route)

  const isOutOfStock = computed(() => {
    if (!response.data.value && !response.pending.value) {
      return true
    }

    return response.data?.value?.isOutOfStock ?? false
  })

  const selectedOffer = computed(() => {
    if (!response.data?.value?.selectedOffer || isOutOfStock.value) {
      return null
    }

    return filterSelectedOfferABTestedPaymentMethods(
      experiments,
      response.data.value?.selectedOffer,
    )
  })

  // `Object.assign` (not spread) keeps the useAsyncData Promise shape so callers can
  // `await useFetchPickers()` to wait for the underlying fetch. Spread would drop
  // `then`/`catch`/`finally` since those are inherited from Promise.prototype, not own.
  return Object.assign(response, {
    pickersResponseCacheTagHeader,
    isOutOfStock,
    selectedOffer,
  })
}
